import { useState } from "react";
import Button from "../../../components/button";
import { API_BASE_URL } from "../../../api/endpoint";
import UpdateModal from "./updateModal";
import { useSelector } from "react-redux";

const PrivacyPolicy = ({ fetchConfig }) => {
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const { config } = useSelector((state) => state.config);

  return (
    <div className="my-3">
      <div className="d-flex justify-content-end">
        <Button
          text="Update Privacy Policy"
          callBack={() => setIsUpdateOpen(true)}
        />
      </div>
      {config?.privacyPolicyFile ? (
        // <div className="my-3" style={{ height: "100vh" }}>
        //   <object
        //     data={`${API_BASE_URL}public/images/${config?.privacyPolicyFile}`}
        //     type="application/pdf"
        //     width="100%"
        //     height="100%"
        //   />
        //   <iframe
        //     src={`${API_BASE_URL}public/images/${config?.privacyPolicyFile}`}
        //     width="100%"
        //     height="100%"
        //     style={{ border: "none" }}
        //   >
        //     <p>
        //       Your browser does not support PDFs.{" "}
        //       <a
        //         href={`${API_BASE_URL}public/images/${config?.privacyPolicyFile}`}
        //         target="_blank"
        //       >
        //         Download PDF
        //       </a>
        //     </p>
        //   </iframe>
        // </div>
        <a
          href={`${API_BASE_URL}public/images/${config?.privacyPolicyFile}`}
          target="_blank"
        >
          View File
        </a>
      ) : (
        <div>No Privacy File Uploaded</div>
      )}
      <UpdateModal
        isUpdateOpen={isUpdateOpen}
        closeUpdateModal={() => setIsUpdateOpen(false)}
        fetchConfig={fetchConfig}
      />
    </div>
  );
};

export default PrivacyPolicy;
